import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import Modal from '../Modal';
import Icon, { GLYPHS } from '../icon';

const SetupPaymentInfoModal = ({
  onCloseHandler,
  onSetupPaymentInfoHandler,
  isOpen,
  isUSBased,
}) => (
  <Modal close={onCloseHandler} className="c-stripe-info-modal c-modal-new" showCloseButton display-if={isOpen}>
    <div className="o-flexbox o-flexbox--content-align-center o-flexbox--column u-p+">
      <Icon glyph={GLYPHS.capital} size="large" className="c-modal-new__header-icon" />
      <div className="c-modal-new__header">Let's get you paid</div>

      {isUSBased ? (
        <Fragment>
          <p className="c-modal-new__text">To allow us to identify you, as part of the USA Patriot Act,
            we will ask for your name, physical address, date of birth and tax payer ID.</p>

          <p className="c-modal-new__text">
            We may ask for other information, such as driver's license or other documents.
            You will also set a banking destination for your funds.</p>
        </Fragment>
      ) : (
        <Fragment>
          <p className="c-modal-new__text">To allow us to identify you, we may ask for your name,
            physical address, date of birth and other identification.</p>

          <p className="c-modal-new__text">You will also set a banking destination
            <br />for your funds.</p>
        </Fragment>
      )}

      <button
        className="c-btn c-btn--medium u-mt+ u-width-100"
        onClick={onSetupPaymentInfoHandler}
      >
        Setup your profile
      </button>
    </div>
  </Modal>
);

SetupPaymentInfoModal.propTypes = {
  onCloseHandler: PropTypes.func,
  onSetupPaymentInfoHandler: PropTypes.func,
  isOpen: PropTypes.bool,
  isUSBased: PropTypes.bool.isRequired,
};

SetupPaymentInfoModal.defaultProps = {
  isOpen: false,
  onCloseHandler: noop,
  onSetupPaymentInfoHandler: noop,
};

export default SetupPaymentInfoModal;
